import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import * as compose from 'lodash.flowright';
import { Mutation } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";

import { description, validateForm, image , cv} from '../../../validations/validation';


// styles , icons and images
import { Container, Row, Col, Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import EditIcon from '@material-ui/icons/Edit';
import { Button, TextField, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleFilled';
import Skeleton from '@material-ui/lab/Skeleton';

import img from '../../../images/person-placeholder.jpg';
// this component respresents the Explore opportunities page

class SideProfileInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {
                profileImg: '',
                bio: '',
                cv: ''
            }
        }
    }
    getUserData = () => {
        if (localStorage.jwt) {
            //handle fetch specialities and tags dropdown   
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            const id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
            apolloFetch({
                query:
                    `query($user_id : Int !){
                        user(id: $user_id){
                        id
                        name
                        email
                        image
                        is_active
                        is_verified
                        created_at
                        updated_at
                        my_bio{
                            title
                            speciality{
                                name
                            }
                            created_at
                            video{
                            duration 
                            frame{
                                url
                            }
                            url
                            }
                        }
                        Locale
                        address
                        image
                        cities_id
                        countries_id
                        phone
                        headlines
                        date_of_birth
                        bio
                        years_of_experience
                        profile_image{
                            url
                        }
                        profile_pdf{
                            url
                        }
                  }
              }
       `, variables: { user_id: id }
            }).then(res => {
                console.log(res.data.user);
                this.setState({ ...this.state, userData: res.data.user })
            });
        }
    }
    componentDidMount() {
        this.getUserData()
    }
    componentWillReceiveProps(props) {
        if (props) {
            this.setState({ ...this.state, userData: props.data });
        }
    }
    closeProfilePic = () => this.setState({ ...this.state, showProilePic: false });
    closeBio = () => this.setState({ ...this.state, showBio: false });
    closeVideo = () => this.setState({ ...this.state, showVideo: false });
    closeCv = () => this.setState({ ...this.state, showCv: false });
    render() {
        const apolloCache = new InMemoryCache({
            addTypename: false
        })
        const token = (localStorage.getItem('jwt')) ? JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token : '';

        const uploadLink = createUploadLink({
            uri: 'https://spreago.black-squares.com/graphql',
            headers: {
                authorization: token ? `Bearer ${token}` : ""
            }
        })
        const client = new ApolloClient({
            cache: apolloCache,
            link: uploadLink
        })

        if (!this.state.userData) {
            return (
                // loader 
                <div className="">
                    <Row className="w-100 pr-4 pl-4 m-0">
                        <Col md={12} className="text-center">
                            <div className="p-relative m-auto" style={{ width: "170px", height: "170px" }}>
                                <Skeleton className="text-center mb-1" variant="circle" animation="wave" width={170} height={170} />
                            </div>
                        </Col>
                        <Col md={12} className=" text-center">
                            <div className="p-relative m-auto w-100">
                                <Skeleton className="text-center mb-1" animation="wave" width={120} height={30} />
                                <Skeleton className="text-center mb-1" animation="wave" height={30} />
                                <Skeleton className="text-center" animation="wave" width={70} height={30} />
                            </div>
                        </Col>
                        <Col md="12">
                            <Skeleton className="text-center" animation="wave" varient="rect" height={120} />
                        </Col>
                    </Row>
                </div>
            )
        }
        else {
            return (
                <ApolloProvider client={client}>
                    <Row className="w-100 pr-4 pl-4 m-0">
                        {/* profile image */}
                        <Col md={12} className="text-center">
                            <div className="p-relative m-auto" style={{ width: "150px", height: "150px" }}>
                                <img
                                    style={{ height: '100%', width: '100%' }}
                                    className="shadow rounded-circle"
                                    src={(this.state.userData.profile_image) ? this.state.userData.profile_image.url : img}
                                    alt="" />
                                <button
                                    className="rounded-circle border-0 btn-orange-gradiant shadow p-absolute"
                                    style={{ width: "45px", height: "45px", bottom: '0', right: '5px' }}
                                >
                                    <label style={{ cursor: 'pointer' }} for="uploadImage"><AddIcon className="text-white" style={{ fontSize: "35px" }} /></label>
                                </button>
                                <input
                                    onChange={e => {
                                        // make sure that the user attache file
                                        let errors = this.state.errors;
                                        if (e.target.files[0]) {
                                            errors.profileImg = image(e.target.files[0])
                                            this.setState({ ...this.state, profilePic: e.target.files[0], showProilePic: true })
                                        }
                                    }}
                                    type="file"
                                    accept='image/*'
                                    className="d-none" id="uploadImage" />
                            </div>
                        </Col>
                        {/* years of experience and name */}
                        <Col md={12} className="mt-3 text-center">
                            <div>
                                <div>
                                    <p className="mb-0 text-grey">
                                    {(this.state.userData.years_of_experience) ? this.state.userData.years_of_experience + " years of experience" : ''}
                                    </p>
                                </div>
                                <div>
                                    <h4 className="captialize">{this.state.userData.name}</h4>
                                </div>
                                <div>
                                    <h6 className="bold">
                                    {(this.state.userData.headlines) ? this.state.userData.headlines : ''}
                                    </h6>
                                </div>
                            </div>
                        </Col>
                        {/* number of followers */}
                        <Col xs={4} className="text-center p-0">
                            <div className="text-orange"><p className="mb-0">250</p></div>
                            <div className=""><p>Followers</p></div>
                        </Col>
                        <Col xs={4} className="text-center p-0">
                            <div className="text-orange"><p className="mb-0">1,345</p></div>
                            <div className=""><p>Video views</p></div>
                        </Col>
                        <Col xs={4} className="text-center p-0">
                            <div className="text-orange"><p className="mb-0">584</p></div>
                            <div className=""><p>Following</p></div>
                        </Col>
                        <Col md={12} className="w-100 border-bottom mt-3 mb-3"></Col>
                        {/* bio */}
                        <Col md={12}>
                            <Row className="m-0">
                                <Col className="p-0 text-left">
                                    <h5>Bio</h5>
                                </Col>
                                <Col className="p-0 text-right">
                                    <button
                                        className="border-0 bg-transparent"
                                        onClick={e => this.setState({ ...this.state, showBio: true })}
                                    ><EditIcon className="text-darkgrey" style={{ fontSize: '1rem' }} /></button>
                                </Col>
                            </Row>
                            <div>
                                <p className="mb-0">
                                    {(this.state.userData.bio) ?
                                        ((this.state.userData.bio.length > 100) ? this.state.userData.bio.substring(0, 100) + "..." : this.state.userData.bio.substring(0, 100))
                                        : 'Click edit and write your bio'}
                                </p>
                            </div>
                        </Col>
                        <Col md={12} className="w-100 border-bottom mt-3 mb-3"></Col>
                        {/* profile visume */}
                        <Col md={12}>
                            <div className="">
                                <h5>Profile Visume</h5>
                            </div>
                            {(this.state.userData.my_bio) ?
                                <div>
                                    <button
                                        type="button"
                                        className="bg-transparent border-0 p-0 play-icon-container"
                                        onClick={e => {
                                            this.setState({ ...this.state, showVideo: true })
                                        }}>
                                        <img className="rounded" src={(this.state.userData.my_bio.video.frame.url) ? this.state.userData.my_bio.video.frame.url : ''} alt="video poster" width="100%" style={{ maxHeight: '6.5rem' }} />
                                        <div className="text-white play-icon row m-0 align-items-center">
                                            <PlayCircleOutlineIcon style={{ fontSize: '2.5rem' }} className="col" />
                                        </div>
                                    </button>
                                    <div>
                                        <div><p className="mb-0 mt-1 captialize bold">{this.state.userData.my_bio.title}</p></div>
                                        <Row className="m-0 p-0 align-items-start mt-1">
                                            <Col className="text-left p-0">
                                                <p className="text-orange mb-0 bold" style={{ fontSize: '12px' }}>
                                                    {this.state.userData.my_bio.speciality.name}
                                                </p>
                                            </Col>
                                            <Col className="text-left">
                                                <p className="text-grey mb-0" style={{ fontSize: '12px' }}>
                                                    {this.state.userData.my_bio.created_at.substring(0, 10)}
                                                </p>
                                            </Col>
                                            <Col className="text-right p-0">
                                                <p className="text-gre mb-0y" style={{ fontSize: '12px' }}>
                                                    {this.state.userData.my_bio.video.duration}
                                                </p>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Modal
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter pr-0"
                                        centered
                                        className="row m-0 modal-video"
                                        show={this.state.showVideo}
                                        onHide={this.closeVideo}>
                                        <Col xs={12} className="p-0">
                                            <Modal.Body className="p-0 bg-white rounded border-b-0">
                                                <Col xs={12} className="text-left  bold  captialize">
                                                    <h6 className='mb-0 pt-3 pb-3'>{this.state.userData.my_bio.title}</h6>
                                                </Col>
                                                <Col xs={12} className="p-0 bg-black rounded">
                                                    <video controls autoPlay title={this.state.userData.my_bio.title} src={this.state.userData.my_bio.video.url} className='iframe-sm ' width="100%" style={{ maxHeight: '33rem' }}></video>
                                                </Col>
                                            </Modal.Body>
                                        </Col>
                                    </Modal>
                                    <Col md={12} className="w-100 border-bottom mt-3 mb-3"></Col>
                                </div> :
                                ''}
                            <div className="pt-0 pb-3">
                                <Row className="m-0 p-0 align-items-center">
                                    {(this.state.userData.profile_pdf) ?
                                        <Col className="p-0">
                                            {/* <iframe title="your cv" size="small" align="top"frameborder="0" scrolling="auto" target="Message"  style={{ width : '18rem' , height : '7rem' }} frameBorder="0" src={this.state.userData.profile_pdf.url} ></iframe> */}
                                            <h6>Preview uploaded <a target="_blank" rel="noopener noreferrer" href={this.state.userData.profile_pdf.url}><span className="text-orange">CV</span></a></h6>
                                        </Col>
                                        : ''}
                                    <Col md={12} className="p-0 pt-1">
                                        <Button style={{ fontSize: '12px', fontWeight: '200' }}
                                            className="bg-dark-h-orange text-white w-100">
                                            <label for="uploadCv" className="w-100">Upload CV</label>
                                        </Button>
                                        <input
                                            type="file"
                                            id="uploadCv"
                                            className="d-none"
                                            accept="application/pdf,application/msword,
                                                application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            onChange={e => {
                                                // make sure that the user attache file
                                                let errors = this.state.errors;
                                                if (e.target.files[0]) {
                                                    errors.cv = cv(e.target.files[0]);
                                                    this.setState({ ...this.state, cv: e.target.files[0], showCv: true })
                                                }
                                            }} />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        
                        {/* imge profile pop up */}
                        <Modal
                            size="md"
                            centered
                            className="row m-0 custom-modal-delete pr-0"
                            show={this.state.showProilePic}
                            onHide={this.closeProfilePic}>
                            <Col xs={12} className="p-0">
                                <Modal.Body className="p-1">
                                    <div className="rounded-circle w-100 text-center">
                                        {this.state.profilePic &&
                                            <img className="rounded-circle"
                                                style={{ width: "150px", height: "150px" }}
                                                src={URL.createObjectURL(this.state.profilePic)}
                                                alt="profile pic"
                                            />
                                        }
                                    </div>
                                    <div className="text-danger">{this.state.errors.profileImg}</div>
                                </Modal.Body>
                                <Modal.Footer className="custom pt-3 pl-0 pr-0 pb-0">
                                    <Row className="m-0 w-100">
                                        <Col xs={6} className="text-left p-0">
                                            <Button
                                                type="button"
                                                size="large"
                                                className="btn-white-outline  pr-4 pl-4" variant="contained"
                                                onClick={() => {
                                                    this.closeProfilePic();
                                                }}>
                                                Cancel
                                                </Button>
                                        </Col>
                                        <Col xs={6} className="text-right p-0">
                                            <Mutation mutation={SAVE_DATA}>
                                                {(Userupdate, { data, loading }) =>
                                                    <div>
                                                        <Button
                                                            type="button"
                                                            size="large"
                                                            className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                                            onClick={() => {
                                                                let file = this.state.profilePic;
                                                                if (validateForm(this.state.errors.profileImg)) {
                                                                    Userupdate({
                                                                        variables: {
                                                                            profile_image: file
                                                                        }
                                                                    }).then((res) => {
                                                                        if (res.data.Userupdate.Status.code === 200) {
                                                                            this.closeProfilePic();
                                                                            this.getUserData();
                                                                        }

                                                                    }).catch((err) => console.log(err));
                                                                }
                                                            }}>
                                                            Save
                                                            </Button>
                                                        {loading &&
                                                            <div className="loading">
                                                                {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                <Loader
                                                                    type="TailSpin"
                                                                    color="white"
                                                                    height={50}
                                                                    width={50}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </Mutation>
                                        </Col>
                                    </Row>
                                </Modal.Footer>
                            </Col>
                        </Modal>
                        {/* bio pop up */}
                        <Modal
                            size="md"
                            centered
                            className="row m-0  pr-0"
                            show={this.state.showBio}
                            onHide={this.closeBio}>
                            <Col xs={12} className="p-0">
                                <Modal.Header className="p-2 pr-3 pl-3 bg-lightgrey" closeButton>
                                    <Modal.Title className="h5 ">Edit Bio</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="p-2 pr-3 pl-3">
                                    <div className="rounded-circle w-100 ">
                                        <div><h5>Bio</h5></div>
                                        <TextField
                                            defaultValue={(this.state.userData.bio) ? this.state.userData.bio : ''}
                                            className="pt-1 pb-1"
                                            onChange={e =>{ 
                                                let errors = this.state.errors;
                                                errors.bio = description(e.target.value);
                                                this.setState({ ...this.state, bio: e.target.value})}}
                                            multiline
                                            rows="7"
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Write your bio"
                                            helperText="0 / 5000 Characters"
                                        />
                                    </div>
                                    <Col xs={12} className="p-0">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.errors.bio}</Typography>
                                    </Col>
                                </Modal.Body>
                                <Modal.Footer className="custom pr-3 pl-3 border-0">
                                    <Row className="m-0 w-100">
                                        <Col xs={6} className="text-left p-0">
                                            <Button
                                                type="button"
                                                size="large"
                                                className="btn-white-outline  pr-4 pl-4" variant="contained"
                                                onClick={() => {
                                                    this.closeBio();
                                                }}>
                                                Cancel
                                                    </Button>
                                        </Col>
                                        <Col xs={6} className="text-right p-0">
                                            <Mutation mutation={SAVE_DATA}>
                                                {(Userupdate, { data, loading }) =>
                                                    <div>
                                                        <Button
                                                            type="button"
                                                            size="large"
                                                            className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                                            onClick={() => {
                                                                let bio = this.state.bio;
                                                                if (validateForm(this.state.errors.bio)) {
                                                                    Userupdate({
                                                                        variables: {
                                                                            bio: bio
                                                                        }
                                                                    }).then((res, loading) => {
                                                                        if (res.data.Userupdate.Status.code === 200) {
                                                                            this.closeBio();
                                                                            this.getUserData();
                                                                        }

                                                                    }).catch((err) => console.log(err));
                                                                }
                                                            }}>
                                                            Save
                                                        </Button>
                                                        {loading &&
                                                            <div className="loading">
                                                                {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                <Loader
                                                                    type="TailSpin"
                                                                    color="white"
                                                                    height={50}
                                                                    width={50}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </Mutation>
                                        </Col>
                                    </Row>
                                </Modal.Footer>
                            </Col>
                        </Modal>
                        {/* upload cv pop up */}
                        <Modal
                            size="lg"
                            centered
                            className="row m-0 custom-modal-delete pr-0"
                            show={this.state.showCv}
                            onHide={this.closeCv}>
                            <Col xs={12} className="p-0">
                                <Modal.Body className="p-1">
                                    <div className="rounded-circle w-100 text-center">
                                        <iframe title="your cv" frameBorder="0" src={(this.state.cv) ? URL.createObjectURL(this.state.cv) : ''} style={{ width: '600px', height: '500px' }} frameborder="0"></iframe>
                                    </div>
                                    <div><p className="text-danger">{this.state.errors.cv}</p></div>
                                </Modal.Body>
                                <Modal.Footer className="custom pt-3 pl-0 pr-0 pb-0">
                                    <Row className="m-0 w-100">
                                        <Col xs={6} className="text-left p-0">
                                            <Button
                                                type="button"
                                                size="large"
                                                className="btn-white-outline  pr-4 pl-4" variant="contained"
                                                onClick={() => {
                                                    this.closeCv();
                                                }}>
                                                Cancel
                                            </Button>
                                        </Col>
                                        <Col xs={6} className="text-right p-0">
                                            <Mutation mutation={SAVE_DATA}>
                                                {(Userupdate, { data, loading }) =>
                                                    <div>
                                                        <Button
                                                            type="button"
                                                            size="large"
                                                            className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                                            onClick={() => {
                                                                let file = this.state.cv;
                                                                if(validateForm(this.state.errors.cv)){
                                                                    Userupdate({
                                                                        variables: {
                                                                            profile_pdf: file
                                                                        }
                                                                    }).then((res, loading) => {
                                                                        if (res.data.Userupdate.Status.code === 200) {
                                                                            this.closeCv();
                                                                            this.getUserData();
                                                                        }

                                                                    }).catch((err) => console.log(err));
                                                                }
                                                            }}>
                                                            Save
                                                        </Button>
                                                        {loading &&
                                                            <div className="loading">
                                                                {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                <Loader
                                                                    type="TailSpin"
                                                                    color="white"
                                                                    height={50}
                                                                    width={50}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </Mutation>
                                        </Col>
                                    </Row>
                                </Modal.Footer>
                            </Col>
                        </Modal>
                    </Row>
                </ApolloProvider>
            );
        }
    }
}
const SAVE_DATA = gql`
mutation($profile_image : Upload $bio : Text $profile_pdf : Upload ){
    Userupdate(data: {
      profile_image : $profile_image
      profile_pdf : $profile_pdf 
      bio : $bio
    }){
      user{
        id
      }
      Status{
        code
      }
    }
  }
  
`;

export default compose(
    graphql(SAVE_DATA, {
        name: 'saveData'
    })
)(withRouter(SideProfileInfo))

